export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const phone = '+44 7809 570238';
export const email = 'vn@andersenlab.com';
